module.exports = __webpack_public_path__ + "d4de2dca5baa4492e8026a4ed67a1987.pdf";